var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t("title", function () {
        return [
          _c("div", { staticClass: "text-body-2 text-secondary--text mb-3" }, [
            _vm._v(
              "\n      " +
                _vm._s(_setup.t("Стоимость приёма", _setup.options)) +
                "\n    "
            ),
          ]),
        ]
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex mx-n1" },
        [
          _c(_setup.PriceInput, {
            staticClass: "w-100 px-1",
            attrs: {
              max: _setup.price.to,
              "is-visible": _vm.isVisible,
              placeholder: `0 ${_setup.currencySymbol}`,
              autofocus: _vm.autofocus,
              label: _setup.t("От", _setup.options),
            },
            on: { input: _setup.handleInput },
            model: {
              value: _setup.price.from,
              callback: function ($$v) {
                _vm.$set(_setup.price, "from", $$v)
              },
              expression: "price.from",
            },
          }),
          _vm._v(" "),
          _c(_setup.PriceInput, {
            staticClass: "w-100 px-1",
            attrs: {
              min: _setup.price.from,
              "is-visible": _vm.isVisible,
              label: _setup.t("До", _setup.options),
              placeholder: "∞",
            },
            on: { input: _setup.handleInput },
            model: {
              value: _setup.price.to,
              callback: function ($$v) {
                _vm.$set(_setup.price, "to", $$v)
              },
              expression: "price.to",
            },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }